import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { AppComponent } from '@main/app.component';
import { CallbackComponent } from '@main/components/callback/callback.component';
import { HeaderComponent } from '@main/components/header/header.component';
import { HomeComponent } from '@main/components/home/home.component';
import { SidebarComponent } from '@main/components/sidebar/sidebar.component';
import { ROUTES } from '@main/app.routes';

import { SharedModule, RecentRoutesModule } from '@shared';
import {
  AuthService,
  JwtTokenFactory,
  AccountUsersModule,
} from '@account-users';
import { environment } from '@env/environment';
import { EmailModule } from '@email';
import { MaModule } from '@ma';
import { DeliveryStatisticsModule } from '@delivery-statistics';
import { EcomModule } from '@ecom';
import { IntegrationsModule } from '@integrations';
import { MigrationsModule } from '@migrations';
import { RolesModule } from '@roles';
import { PrivateDomainModule } from '@private-domain';
import { BossModule } from '@boss';
import { TrialAccountsModule } from '@trial-accounts';

const COMPONENTS = [
  AppComponent,
  CallbackComponent,
  HeaderComponent,
  HomeComponent,
  SidebarComponent,
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    TrialAccountsModule,
    BossModule,
    AccountUsersModule,
    EmailModule,
    MaModule,
    RolesModule,
    MigrationsModule,
    EcomModule,
    IntegrationsModule,
    RecentRoutesModule,
    DeliveryStatisticsModule,
    PrivateDomainModule,
    BrowserAnimationsModule,
    CommonModule,
    BrowserModule,
    HttpClientModule,
    NgbModule,
    RouterModule.forRoot(ROUTES, { relativeLinkResolution: 'legacy' }),
    SharedModule,
    ToastrModule.forRoot({ preventDuplicates: true }),
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useClass: JwtTokenFactory,
      },
    }),
    StoreModule.forRoot(
      {},
      {
        metaReducers: !environment.production ? [] : [],
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
        },
      },
    ),
    EffectsModule.forRoot([]),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
  ],
  providers: [
    AuthService,
    {
      provide: 'auth0',
      useValue: environment.auth0,
    },
    {
      provide: 'siteUrl',
      useValue: environment.siteUrl,
    },
    {
      provide: 'oneUrl',
      useValue: environment.oneUrl,
    },
    {
      provide: 'avatarBaseUrl',
      useValue: environment.avatarBaseUrl,
    },
    {
      provide: 'apiBaseUrl',
      useValue: environment.apiBaseUrl,
    },
    {
      provide: 'audienceBaseUrl',
      useValue: environment.audienceBaseUrl,
    },
    {
      provide: 'emailBaseUrl',
      useValue: environment.emailBaseUrl,
    },
    {
      provide: 'maBaseUrl',
      useValue: environment.maBaseUrl,
    },
    {
      provide: 'ecomBaseUrl',
      useValue: environment.ecomBaseUrl,
    },
    {
      provide: 'integrationsBaseUrl',
      useValue: environment.integrationsBaseUrl,
    },
    {
      provide: 'smsBaseUrl',
      useValue: environment.smsBaseUrl,
    },
    {
      provide: 'proSyncBaseUrl',
      useValue: environment.proSyncBaseUrl,
    },
    {
      provide: 'webVersionUrl',
      useValue: environment.webVersionUrl,
    },
    {
      provide: 'slimPackage',
      useValue: environment.slimPackage,
    },
    {
      provide: 'privateDomainUrl',
      useValue: environment.privateDomainUrl,
    },
    {
      provide: 'hostUrl',
      useValue: window.location.host,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
